import React from 'react';
import gql from 'graphql-tag';
import { Button, Card, Flex, Text, Box } from 'rebass';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import { useState } from 'react';
import { Mutation, Query } from 'react-apollo';
import PleaseWait from '../components/PleaseWait';
import Modal from 'styled-react-modal';
import { SpecialModalBackground } from './adminReorderPhysicianConvo/shared';
import AdminEditRegion from './adminRegions/AdminEditRegion';

export const GET_ADMIN_REGIONS = gql`
  query listRegions {
    listRegions {
      label
      value
      level
      canBookNutritionist
      canBookAsync
      canBookPeriMenopause
      canBookPostMenopause
      canBookWeightLoss
      departmentName
      postMenoCount
      periMenoCount
      wlCount
      athenaId
    }
  }
`;

const INITIALIZE_REGIONS = gql`
  mutation initializeRegions {
    initializeRegions {
      ok
    }
  }
`;

const getCountSpan = (count, isActive) => {
  if (!count && isActive) {
    return <span style={{ color: 'red', fontSize: '13px' }}>({count})</span>;
  }

  if (!!count && !isActive) {
    return <span style={{ color: 'orange', fontSize: '13px' }}>({count})</span>;
  }
  return <span style={{ color: '#344f79', fontSize: '13px' }}>({count})</span>;
};

export const AdminRegionEdits = () => {
  const [isEdit, setIsEdit] = useState();

  const columns = [
    {
      Header: 'State',
      accessor: 'label',
    },
    {
      Header: 'Code',
      accessor: 'value',
    },
    {
      Header: 'Level',
      accessor: 'level',
    },
    {
      Header: 'Nutritionist',
      accessor: 'canBookNutritionist',
      Cell: (row) => {
        return <div style={{ color: row.original.canBookNutritionist ? 'green' : 'red' }}>{row.original.canBookNutritionist ? '✓' : 'x'}</div>;
      },
    },
    {
      Header: 'Async',
      accessor: 'canBookAsync',
      Cell: (row) => {
        return <div style={{ color: row.original.canBookAsync ? 'green' : 'red' }}>{row.original.canBookAsync ? '✓' : 'x'}</div>;
      },
    },
    {
      Header: 'Peri Menopause',
      accessor: 'canBookPeriMenopause',
      Cell: (row) => {
        return (
          <div style={{ color: row.original.canBookPeriMenopause ? 'green' : 'red' }}>
            {row.original.canBookPeriMenopause ? '✓' : 'x'} {getCountSpan(row.original.periMenoCount, row.original.canBookPeriMenopause)}
          </div>
        );
      },
    },
    {
      Header: 'Post Menopause',
      accessor: 'canBookPostMenopause',
      Cell: (row) => {
        return (
          <div style={{ color: row.original.canBookPostMenopause ? 'green' : 'red' }}>
            {row.original.canBookPostMenopause ? '✓' : 'x'} {getCountSpan(row.original.postMenoCount, row.original.canBookPostMenopause)}
          </div>
        );
      },
    },
    {
      Header: 'Weightloss',
      accessor: 'canBookWeightLoss',
      Cell: (row) => {
        return (
          <div style={{ color: row.original.canBookWeightLoss ? 'green' : 'red' }}>
            {row.original.canBookWeightLoss ? '✓' : 'x'} {getCountSpan(row.original.wlCount, row.original.canBookWeightLoss)}
          </div>
        );
      },
    },
    {
      Header: 'Athena Department',
      accessor: 'departmentName',
    },
    {
      Header: 'Athena ID',
      accessor: 'athenaId',
    },
    {
      Header: '',
      Cell: (row, rest) => {
        return (
          <Flex flexDirection="row">
            <div title="edit" style={{ cursor: 'pointer', marginLeft: '12px' }} onClick={() => onEdit(row.original)}>
              ✎
            </div>
          </Flex>
        );
      },
    },
  ];

  const onEdit = (itm) => {
    setIsEdit(itm);
  };

  return (
    <Flex flexDirection={'column'} mb={4} p={3}>
      <Flex mb={3}>
        <Text flex={1} style={{ fontWeight: 500, fontSize: '20px' }}>
          Departments
        </Text>
      </Flex>

      <Query query={GET_ADMIN_REGIONS}>
        {({ data, loading, error, refetch }) => {
          if (!!loading) {
            return <PleaseWait />;
          }
          if (!data || !data.listRegions || !!error) {
            return <Text textAlign={'center'}>An error occured</Text>;
          }
          if (!!data && data.listRegions.length < 1) {
            return (
              <Mutation mutation={INITIALIZE_REGIONS} refetchQueries={[{ query: GET_ADMIN_REGIONS }]} awaitRefetchQueries>
                {(mutate, { loading }) => (
                  <Button variant={'primary'} onClick={() => mutate()} disabled={!!loading}>
                    Initialize Regions
                  </Button>
                )}
              </Mutation>
            );
          }
          return (
            <>
              <ReactTable
                getTrProps={(state, rowInfo, column, instance) => {
                  if (rowInfo) {
                    // Access the original data of the row
                    const status = rowInfo.original.status;

                    const canBookPeriMenopause = rowInfo.original.canBookPeriMenopause;
                    const canBookPostMenopause = rowInfo.original.canBookPostMenopause;
                    const canBookWeightLoss = rowInfo.original.canBookWeightLoss;
                    const postMenoCount = rowInfo.original.postMenoCount;
                    const periMenoCount = rowInfo.original.periMenoCount;
                    const wlCount = rowInfo.original.wlCount;

                    let backgroundColor = 'white'; // Default color
let isError=false
                    if ((canBookPeriMenopause && !periMenoCount) || (canBookPostMenopause && !postMenoCount) || (canBookWeightLoss && !wlCount)) {
                      isError=true
                      backgroundColor = '#ffe1e1';
                    }

                    if(!isError){
                      if ((!canBookPeriMenopause && !!periMenoCount) || (!canBookPostMenopause && !!postMenoCount) || (!canBookWeightLoss && !!wlCount)) {
                      isError=true
                      backgroundColor = '#fff1e1ff';
                    }
                    }

                    return {
                      style: {
                        background: backgroundColor,
                      },
                    };
                  }
                  return {}; // Return an empty object if no rowInfo (e.g., header or loading)
                }}
                data={data.listRegions}
                columns={columns}
                defaultPageSize={data.listRegions ? data.listRegions.length : 3}
                showPagination={false}
              />
              {!!isEdit && (
                <Modal
                  isOpen={true}
                  onBackgroundClick={() => {
                    setIsEdit(null);
                  }}
                  onEscapeKeydown={() => {
                    setIsEdit(null);
                  }}
                >
                  <SpecialModalBackground>
                    <Box
                      style={{
                        margin: '0 auto',
                        alignSelf: 'center',
                        borderRadius: '20px',
                        position: 'relative',
                        backgroundColor: 'white',
                        padding: '24px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        maxWidth: '95vw',
                        minWidth: 'initial',
                        maxHeight: '95vh',
                      }}
                    >
                      <Flex flex={1} flexDirection={'column'} width={'600px'}>
                        <AdminEditRegion editItem={isEdit} close={() => setIsEdit(null)} refetch={refetch} />
                      </Flex>
                    </Box>
                  </SpecialModalBackground>
                </Modal>
              )}
            </>
          );
        }}
      </Query>
    </Flex>
  );
};
